import React from "react";

const EarningsEvent = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      className={props.className || ""}
      style={{
        fontSize: props.fontSize || "20px",
        pointerEvents: props.pointerEvents || "none",
      }}
    >
      <circle cx="20" cy="20" r="18" strokeWidth="2" />
      <polygon points="20,1.5 5.7,32 34.3,32" fill="white" />
    </svg>
  );
};

export default EarningsEvent;
